import { auth } from "./hu/auth";
import { common } from "./hu/common";
import { customers } from "./hu/customers";
import { dashboard } from "./hu/dashboard";
import { deals } from "./hu/deals";
import { nav } from "./hu/nav";
import { organizations } from "./hu/organizations";
import { products } from "./hu/products";
import { profile } from "./hu/profile";
import { quotations } from "./hu/quotations";
import { reports } from "./hu/reports";
import { systemAdmin } from "./hu/systemAdmin";
import { status } from "./hu/status";
import { debug } from "./hu/debug";
import { contracts } from "./hu/contracts";
import { shared } from "./hu/shared";
import { templates } from "./hu/templates";
import { documents } from "./hu/documents";
import { onboarding } from "./hu/onboarding";
import { gas } from "./hu/gas";

export default {
  auth,
  common,
  nav,
  dashboard,
  customers,
  products,
  quotations,
  deals,
  reports,
  organizations,
  systemAdmin,
  profile,
  status,
  contracts,
  shared,
  debug,
  templates,
  documents,
  onboarding,
  gas
};